var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import HelperFunctions from 'utils/HelperFunctions';
var DateRangeWeek = function (_a) {
    var value = _a.value, activityStartDate = _a.activityStartDate, activityEndDate = _a.activityEndDate, year = _a.year, setRange = _a.setRange;
    var _b = useState([]), weeksList = _b[0], setWeekList = _b[1];
    var helpers = new HelperFunctions();
    var getWeekDates = function () {
        if (value && year) {
            var weekInfo = helpers.getDateRangeOfWeek(value, year.toString());
            return "".concat(weekInfo.dateStart, " - ").concat(weekInfo.dateEnd);
        }
        return '';
    };
    useEffect(function () {
        if (activityStartDate && year) {
            var list = [];
            var firstWeek = helpers.getWeekNumber(new Date(activityStartDate));
            var lastWeek = activityEndDate
                ? new Date() < new Date(activityEndDate)
                    ? helpers.getWeekNumber(new Date())
                    : helpers.getWeekNumber(new Date(activityEndDate))
                : helpers.getWeekNumber(new Date());
            var firstWeekNumber = firstWeek[0] === year ? firstWeek[1] : 1;
            var lastWeekNumber = lastWeek[0] === year ? lastWeek[1] : 52;
            for (var i = firstWeekNumber; i <= lastWeekNumber; i++) {
                list.push(i);
            }
            setWeekList(list);
        }
    }, [activityStartDate, year, activityEndDate]);
    return (_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("div", __assign({ className: "flex flex-wrap max-w-320" }, { children: weeksList.length &&
                    weeksList.map(function (week, index) {
                        return (_jsx("div", __assign({ onClick: function () {
                                setRange('week', week);
                            }, className: clsx("tw-date-range-filter-item", value && week === value && "selected") }, { children: week }), index));
                    }) }), void 0), _jsx("p", { children: getWeekDates() }, void 0)] }), void 0));
};
export default DateRangeWeek;
